import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TeamsService } from '../services/teams.service';
import { TeamInterface } from '../models/team.interface';
import { IdentityService } from '../../../services/identity.service';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { TeamProjectService } from '../../../services/team-project.service';
import { IdentityRole } from '../../../interfaces/identity-role';

export const TeamResolver: ResolveFn<TeamInterface> = (route: ActivatedRouteSnapshot): Observable<TeamInterface> => {
  const teamsService = inject(TeamsService);
  const identityService = inject(IdentityService);
  const teamProjectService = inject(TeamProjectService);

  return teamProjectService.teamProject$.pipe(
    filter(teamProject => Boolean(teamProject)),
    take(1),
    switchMap(teamProject => {
      if (identityService.isTeamAdmin()) {
        const localTeamProject = teamProjectService.teamProjectFromLocalStorage;

        const isCurrentRole = (role: IdentityRole) =>
          role.CompanySlug === teamProject.CompanySlug && role.TeamSlug === teamProject?.TeamSlug;

        const identityData = localTeamProject ? localTeamProject : identityService.identity.Roles.find(isCurrentRole);

        const companySlug = identityData.CompanySlug;
        const teamSlug = identityData.TeamSlug;

        return teamsService.getTeam(companySlug, teamSlug).pipe(tap(team => (identityService.teamPermissions = team.Permissions)));
      }

      if (route.params.companySlug && route.params.teamSlug) {
        teamProjectService.companySlugFromRoute = route.params.companySlug;

        return teamsService.getTeam(route.params.companySlug, route.params.teamSlug);
      }

      return of(null);
    }),
  );
};
